module.exports = __webpack_public_path__ + "img/logo.981d0f4a.png";